import { computed } from "vue"
import { useRoute } from "vue-router"
import { useBreadcrumbStore } from "@/stores/breadcrumb"
import { usePageActions } from "@/stores/pageActions"

export function usePageHeader() {
    const route = useRoute()
    const bc = useBreadcrumbStore()
    const pa = usePageActions()

    const title = computed(() => bc.title ?? (route.meta.title as string) ?? String(route.name ?? ""))
    const description = computed(() => bc.description ?? (route.meta.description as string) ?? "")

    const breadcrumb = computed(() => {
        const meta = route.matched.flatMap(r => {
            const m = r.meta?.breadcrumb as any
            return m ? (typeof m === "function" ? m(route) : m) : []
        })
        return bc.items.length ? bc.items : (meta.length ? meta : [{ label: title.value }])
    })

    const actions = computed(() => pa.items.length ? pa.items : ((route.meta.actions as any[]) || []))
    return { title, description, breadcrumb, actions }
}
